import React, { useState } from "react";
import { Modal, Button, Form, Alert, InputGroup } from "react-bootstrap";
import {
  IconPlus,
  IconMinus,
  IconShoppingCart,
  IconInfoCircle,
} from "@tabler/icons-react";
import PlanServices from "../../../services/PlanServices";

const ContractAddonModal = ({ show, onHide, addon, onConfirm }) => {
  const [quantity, setQuantity] = useState(1);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!addon) {
    return null;
  }

  const handleQuantityChange = (delta) => {
    const newQuantity = Math.max(1, Math.min(10, quantity + delta));
    setQuantity(newQuantity);
  };

  const handleConfirm = async () => {
    if (!acceptedTerms) return;

    setLoading(true);
    try {
      await onConfirm(addon, quantity);
    } finally {
      setLoading(false);
    }
  };

  const totalPrice = addon.price * quantity;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center">
          <IconShoppingCart size={24} className="text-primary me-2" />
          Contratar Recurso Adicional
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Informações do addon */}
        <div className="text-center mb-4 p-4 bg-light rounded">
          <h5 className="mb-2">{addon.name}</h5>
          <p className="text-muted mb-0">
            {PlanServices.formatCurrency(addon.price)} por {addon.unit}/mês
          </p>
        </div>

        {/* Seletor de quantidade */}
        <Form.Group className="mb-4">
          <Form.Label className="fw-semibold">Quantidade</Form.Label>
          <InputGroup>
            <Button
              variant="outline-secondary"
              onClick={() => handleQuantityChange(-1)}
              disabled={quantity <= 1}
            >
              <IconMinus size={18} />
            </Button>
            <Form.Control
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(Math.max(1, Math.min(10, parseInt(e.target.value) || 1)))}
              min={1}
              max={10}
              className="text-center"
              style={{ maxWidth: "80px" }}
            />
            <Button
              variant="outline-secondary"
              onClick={() => handleQuantityChange(1)}
              disabled={quantity >= 10}
            >
              <IconPlus size={18} />
            </Button>
          </InputGroup>
          <Form.Text className="text-muted">
            Máximo de 10 unidades por contratação
          </Form.Text>
        </Form.Group>

        {/* Resumo do valor */}
        <div className="p-3 bg-primary bg-opacity-10 rounded mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">Total mensal:</span>
            <span className="fs-4 fw-bold text-primary">
              {PlanServices.formatCurrency(totalPrice)}
            </span>
          </div>
          <small className="text-muted">
            {quantity}x {addon.name} = {PlanServices.formatCurrency(totalPrice)}/mês
          </small>
        </div>

        {/* Aceite dos termos */}
        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            id="accept-addon-terms"
            label={
              <span>
                Entendo que este valor será adicionado à minha fatura mensal
              </span>
            }
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
          />
        </Form.Group>

        {/* Aviso */}
        <Alert variant="info" className="mb-0 d-flex align-items-start">
          <IconInfoCircle size={18} className="me-2 flex-shrink-0 mt-1" />
          <small>
            O recurso adicional será ativado imediatamente após a confirmação
            do pagamento e será cobrado proporcionalmente ao período restante
            do ciclo atual.
          </small>
        </Alert>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={!acceptedTerms || loading}
          className="d-flex align-items-center"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Processando...
            </>
          ) : (
            <>
              <IconShoppingCart size={18} className="me-2" />
              Contratar ({PlanServices.formatCurrency(totalPrice)}/mês)
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContractAddonModal;
